export const ACTION_TYPES = {
  SET_MODAL: "SET_MODAL",
};

//---Modal-----------------------------:

//Update the modal data
export const setModal = (data) => {
  return { type: ACTION_TYPES.SET_MODAL, payload: data };
};
